import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Modal, Spinner, Table } from 'react-bootstrap';
import { SiImessage } from 'react-icons/si';
import { useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import ChatComponent from '../ChatComponent';

const SearchAndShortlist = () => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const location = useLocation();
    const userName = location.state?.userName;
    const userEmail = location.state?.userEmail;

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [searchData, setSearchData] = useState([]);
    const [applicationData, setApplicationData] = useState([]);

    const [resumeTypes, setResumeTypes] = useState({});
    const [fileNames, setFileNames] = useState({});
    const [getcandidateName, setCandidateNameMap] = useState({});
    const [companyName, setCompanyName] = useState('TestCompany');
    const [jobId, setJobId] = useState('123');
    const [showBriefSettings, setShowBriefSettings] = useState(false);
    const [showMessage, setShowMessage] = useState('');
    const [shortlistedIds, setShortlistedIds] = useState([]);
    const [unreadMessages, setUnreadMessages] = useState([]); // State to track unread messages
    const [isResumeBrief, setIsResumeBrief] = useState(false);
    // State to track if the ChatComponent is open
    const [isChatOpen, setIsChatOpen] = useState(false);

    const [chatData, setChatData] = useState({
        applicationId: null,
        candidateId: null,
        hrId: null,
    });
    const searchCandidate = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${BASE_API_URL}/search-candidates`, {
                params: { search, page, size: pageSize }
            });

            const data = response.data;
            setSearchData(data.content || []);
            setTotalPages(data.totalPages || 0);

            const nameMap = {};
            const types = {};
            const files = {};

            for (const candidate of data.content || []) {
                // Fetch username from backend using userId
                const name = await fetchUserNameById(candidate.userId);
                nameMap[candidate.userId] = name;

                types[candidate.id] = candidate.resumeType || '';
                files[candidate.id] = candidate.resumeFile || '';
            }

            setCandidateNameMap(nameMap);
            setResumeTypes(types);
            setFileNames(files);

        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    const fetchUserNameById = async (userId) => {
        try {
            const response = await axios.get(`${BASE_API_URL}/getUserName`, {
                params: { userId }
            });
            return response.data.userName;
        } catch (error) {
            return 'N/A';
        }
    };

    // shortlist function
    const shortlist = async (candidate) => {
        try {
            const response = await axios.put(`${BASE_API_URL}/shortlist`, null, {
                params: {
                    userId: candidate.userId,
                    resumeId: candidate.id,
                    hrEmail: userEmail
                }
            });

            if (response.status === 200) {
                toast.success(`Candidate marked as shortlisted!`);
                const ids = await axios.get(`${BASE_API_URL}/getsearchAndshortlistIds`, {
                    params: { hrEmail: userEmail },
                });
                // Replace shortlistedIds to avoid duplicates
                setShortlistedIds(ids.data);
            } else {
                alert('Failed to shortlist candidate.');
            }
        } catch (error) {
            alert('Error shortlisting candidate.');
        }
    };

    const getApplications = async () => {
        setLoading(true);
        const unread = {}; // Initialize unread messages state
        try {
            const response = await axios.get(`${BASE_API_URL}/get-applications-searchAndshortlist`, {
                params: { hrEmail: userEmail, page, size: pageSize },
            });
            const data = response.data;
            setApplicationData(data.content || []);
            setTotalPages(data.totalPages || 0);

            const ids = await axios.get(`${BASE_API_URL}/getsearchAndshortlistIds`, {
                params: { hrEmail: userEmail },
            });

            // Replace shortlistedIds to avoid duplicates
            setShortlistedIds(ids.data);
            for (const application of data.content) {
                const countUnread = await fetchCountUnreadMessage(application.applicationId);
                unread[application.applicationId] = countUnread;
            }
            setUnreadMessages(unread); // Set unread messages state
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (search.trim() !== '') {
            searchCandidate();
        } else {
            getApplications();
        }
    }, [search]);

   const fetchCountUnreadMessage = async (applicationId) => {
   try {
     const response = await axios.get(`${BASE_API_URL}/fetchCountUnreadMessageForHRByApplicationId`, {
       params: {
         applicationId,
         userEmail
       }
     });
     return response.data;
   } catch (error) {
     console.error('Error fetching unread message count:', error);
     // You can throw error or return null/0 depending on your needs
   }
 };
    const renderResumeComponent = (candidate) => {
        const fileType = candidate.fileType;
        const fileName = candidate.fileName;

        if (fileType === 'file') {
            return (
                <Button className="btn-sm" variant="primary" onClick={() => handleDownload(candidate.id, fileName)}>Download</Button>
            );
        } else if (fileType === 'link') {
            return (
                <a href={fileName} target="_blank" rel="noopener noreferrer" onClick={() => updateViewCount(candidate.id, "link")}>Click here</a>
            );
        } else if (fileType === 'brief') {
            return (
                <Button className="btn-sm" variant="primary" onClick={() => {
                    updateViewCount(candidate.id, "brief");
                    openPopup(fileName);
                }}>Open Brief</Button>
            );
        } else {
            return null;
        }
    };

    const handleDownload = async (resumeId, fileName) => {
        const action = "download";
        try {
            await axios.post(`${BASE_API_URL}/resume-increment-view`, null, {
                params: { resumeId, action, companyName, jobId },
            });

            const response = await axios.get(`${BASE_API_URL}/downloadResume?resumeId=${resumeId}`, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
        }
    };

    const updateViewCount = async (resumeId, action) => {
        try {
            await axios.post(`${BASE_API_URL}/resume-increment-view`, null, {
                params: { resumeId, action, companyName, jobId },
            });
        } catch (error) {
        }
    };

    const openPopup = (fileName) => {
        setShowMessage(fileName);
        setShowBriefSettings(true);
    };
    // Function to handle chat icon click
    const toggleChat = async (application) => {
        // Set the chat data for the clicked application
        // Mark messages as read
        axios.put(`${BASE_API_URL}/markCandidateMessagesAsRead?applicationId=${application.applicationId}`);
        const unread = {}; // Initialize unread messages state
        try {

            const countUnread = fetchCountUnreadMessage(application.applicationId);

            unread[application.applicationId] = countUnread;
            const response = await axios.get(`${BASE_API_URL}/getResumeByApplicationId?resumeId=${application.resumeId}`);

            // Assuming response.data is an object with the fileType field
            const fileType = response.data.fileType; // Correctly access fileType from response data


            if (fileType === 'brief') {
                setIsResumeBrief(true);  // Set the state to true if fileType is 'brief'
            } else {
                setIsResumeBrief(false); // Set the state to false if fileType is not 'brief'
            }

        } catch (error) {
        }
        setUnreadMessages(unread); // Set unread messages state
        setChatData({
            applicationId: application.applicationId,
            candidateId: application.candidateId,
            hrId: application.hrId,
        });
        // Toggle the visibility of the ChatComponent
        setIsChatOpen(!isChatOpen);
    };
    return (
        <div className="p-4">


            <div className="mb-3 row align-items-center">
                <div className="col-12 col-md d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div className="fw-semibold mb-2 mb-md-0">
                        Search candidates and shortlist directly
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <input
                            type="text"
                            placeholder="Search..."
                            className="form-control form-control-sm"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            style={{ width: '300px', height: '40px' }}
                        />
                        {search && (
                            <Button
                                onClick={() => setSearch('')}
                                type="button"
                            >
                                Clear
                            </Button>
                        )}
                    </div>
                </div>
            </div>






            {loading ? (
                <div className="d-flex align-items-center">
                    <Spinner animation="border" variant="primary" className="me-2" />
                    <span>Loading...</span>
                </div>
            ) : (
                <>
                    {search.trim() !== '' ? (
                        <>
                            <h5>Search Results</h5>
                            {searchData.length > 0 ? (
                                <Table  hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Resume</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {searchData.map((candidate, index) => {
                                            const shortlisted = shortlistedIds.includes(candidate.userId);
                                            return (
                                                <tr key={index}>
                                                    <td>{candidate.fileType === 'brief' ? 'Ninja Applicant' : (getcandidateName[candidate.userId] || 'N/A')}</td>
                                                    <td>{renderResumeComponent(candidate)}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => shortlist(candidate)}
                                                            disabled={shortlisted}
                                                        >
                                                            {shortlisted ? 'Shortlisted' : 'Mark as Shortlist'}
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            ) : (
                                <p className="text-center">No results found.</p>
                            )}
                        </>

                    ) : (
                        <>
                            <h5>Shortlisted Candidate</h5>
                            {applicationData.length > 0 ? (
                                <Table  hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Applied Date</th>
                                            <th>Status</th>
                                            <th>Chat</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {applicationData.map((app, index) => (
                                            <tr key={index}>
                                                <td>{app.candidateName}</td>
                                                <td>{app.appliedOn}</td>
                                                <td>{app.applicationStatus}</td>
                                                <td>
                                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                                        {unreadMessages[app.applicationId] > 0 && (
                                                            <span
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '-5px',
                                                                    right: '-15px',
                                                                    backgroundColor: 'red',
                                                                    color: 'white',
                                                                    borderRadius: '50%',
                                                                    width: '20px',
                                                                    height: '20px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    fontSize: '12px',
                                                                    fontWeight: 'bold',
                                                                    zIndex: 1, // Ensure notification badge is above SiImessage icon
                                                                }}
                                                            >
                                                                {unreadMessages[app.applicationId]}
                                                            </span>
                                                        )}

                                                        {/* Chat icon, click to toggle the ChatComponent */}
                                                        <SiImessage
                                                            size={25}
                                                            onClick={() => toggleChat(app)}
                                                            style={{ color: 'green', cursor: 'pointer' }}
                                                        />

                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <p className="text-center">No applications found.</p>
                            )}
                        </>

                    )}
                </>
            )}

            {showBriefSettings && (
                <Modal show={showBriefSettings} onHide={() => setShowBriefSettings(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Brief Resume</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ overflowY: 'auto' }}>{showMessage}</Modal.Body>
                </Modal>
            )}
            {/* Conditionally render the ChatComponent */}
            {isChatOpen && (
                <ChatComponent
                    applicationId={chatData.applicationId}
                    candidateId={chatData.candidateId}
                    hrId={chatData.hrId}
                    userType='HR'
                    setIsChatOpen={setIsChatOpen}
                    isResumeBrief={isResumeBrief}
                />
            )}

            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
        </div>
    );
};

export default SearchAndShortlist;
